import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import excluirVeiculo from '../../actions/veiculo/excluirVeiculo';
import { alterouPagina } from '../../util/filtros';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import ModalCadastrarVeiculo from './ModalSelecionarMapaVeiculo';
import Veiculo from './Veiculo';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import PaginacaoVeiculos from './PaginacaoVeiculos';
import BotoesPaginacaoVeiculos from './BotoesPaginacaoVeiculos';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import ModalLocalizacaoVeiculo from './ModalLocalizacaoVeiculo';
import filtrarResumoVeiculo from '../../actions/veiculo/filtrarResumoVeiculo';
import selecionarVeiculo from '../../actions/veiculo/selecionarVeiculo';
import alterarMapaSelecionadoVeiculo from '../../actions/veiculo/alterarMapaSelecionadoVeiculo';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table">
    <div className="row cabecalho-desktop">
      <div className="col-lg-1 col-xl-1"></div>
      <div className="col-3"></div>
      <div className="col-2">Descrição</div>
      <div className="col-2 col-lg-2 col-xl-3">Quantidade de Assentos</div>
    </div>
  </div>
);

const ModalConfirmacaoExclusaoVeiculo = ({ excluir, veiculo }) => (
  <div className="modal fade" id="modalConfirmacaoExclusaoVeiculo" tabIndex="-1" role="dialog"
    aria-labelledby="modalConfirmacao" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Deseja excluir o veículo <strong>{veiculo ? veiculo.descricao : ''}
          </strong> da empresa selecionada ?</p>
        </div>
        <div className="modal-footer ">
          <button id='cancelar' type="button" className="btn btn-outline-secondary"
            data-dismiss="modal">Cancelar
          </button>
          <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
            onClick={() => excluir()}>Excluir
          </button>
        </div>
      </div>
    </div>
  </div>);

export class PainelGerenciarVeiculos extends React.Component {
  constructor(props) {
    super(props);
    this.selecionarVeiculo = this.selecionarVeiculo.bind(this);
    this.limparCampos = this.limparCampos.bind(this);
    this.excluir = this.excluir.bind(this);
    this.submeterBusca = this.submeterBusca.bind(this);
    this.state = {
      veiculoSelecionado: null,
      textoFiltro: null,
      empresaSelecionada: null
    };
  }

  componentDidMount() {
    if (this.props.empresaSelecionada.id) {
      this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
    }
  }

  limparveiculoSelecionado() {
    this.setState({ veiculoSelecionado: null });
  }


  excluir() {
    this.props.excluirVeiculo(this.state.veiculoSelecionado.id, this.props.empresaSelecionada.id)
      .then(() => {
        this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
        this.limparveiculoSelecionado();
      })
  }

  submeterBusca(event) {
    this.props.filtrarResumoVeiculo(this.props.resumoVeiculo, event.target.value);
  }

  limparCampos() {
    this.props.changeFieldValue('formularioPainelCadastroVeiculo',
      'mapaVeiculo', '');
    this.props.changeFieldValue('formularioPainelCadastroVeiculo',
      'idVeiculo', '');
    this.props.changeFieldValue('formularioPainelCadastroVeiculo',
      'descricao', '');

    this.limparveiculoSelecionado();
  }


  selecionarVeiculo(veiculo) {
    this.setState({ veiculoSelecionado: veiculo });
    this.props.selecionarVeiculo(veiculo);
  }

  selecionarEmpresa(empresa) {
    this.setState({ empresaSelecionada: empresa })
  }
  
  // eslint-disable-next-line class-methods-use-this
  exibirBotaoCadastrarNovoVeiculo() {
    if (!this.props.empresaSelecionada) {
      return ''
    }
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
        <div className="row">
          <div className="col-md-12">
            <div className="text-right">
                <button type="button" className="btn btn-laranja" title='Painel Cadastrar Veículo'
                    onClick={() => {
                      this.props.selecionarVeiculo(null);
                      this.props.alterarMapaSelecionadoVeiculo(null);
                      this.props.history.push('/painel-cadastro-veiculo');
                    }}>
                    NOVO VEÍCULO
                </button>
            </div>
          </div>
        </div>
      </Autorizacao>
    )
  }

  exibirCampoBusca() {
    if (this.props.resumoVeiculo.length) {
      return (<React.Fragment>
        <div className="input-group mb-3 mt-3">
          <span className="input-group-prepend">
            <button id="btn-campo-busca-processo" type="submit"
              className="input-group-text bg-white btn-campo-busca" disabled={true}>
              <i className="material-icons">&#xe8b6;</i>
            </button>
          </span>
          <input className="form-control form-control-lg campo-busca"
            type="text"
            id="campo-busca-legitimado"
            onChange={this.submeterBusca}
            autoComplete="off"
            placeholder="Buscar na lista abaixo" />
        </div>
      </React.Fragment>);
    }
  }

  exibirTabelaVeiculos() {
    if (!this.props.empresaSelecionada) {
      return ''
    }
    if (this.props.veiculos && this.props.veiculos.length) {
      return (<div className="col-12 conteudo-internas">
        <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoVeiculos}
          BotoesPaginacao={BotoesPaginacaoVeiculos}>
          <CabecalhoTabela />
          <div className="lista-table">
            {this.exibirVeiculos()}
          </div>
        </CabecalhoRodapeTabela>
      </div>
      )
    }
    return <div>Nenhum veículo cadastrado para à empresa selecionada.</div>;
  }

  exibirVeiculos() {
    return this.props.veiculos
      .map((veiculo, index) => <Veiculo key={index} veiculo={veiculo}
        selecionar={this.selecionarVeiculo}
        indice={index} />)
  }


  render() {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id),
        getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
        <div>
          <div className="row internas">
            <Titulo texto="Gerenciar Veiculos" urlRetorno="/" />
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
              <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                  <li className="nav-item dropdown nome-empresa">
                    <div className='col-md-6'>
                      <CampoSelecionarEmpresa />
                    </div>
                  </li>
                </ul>
              </div>
            </Autorizacao>
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
              {this.exibirBotaoCadastrarNovoVeiculo()}
              {this.exibirCampoBusca()}
              {this.exibirTabelaVeiculos()}
            </div>
          </div>
          <ModalCadastrarVeiculo veiculo={this.state.veiculoSelecionado} />
          <ModalConfirmacaoExclusaoVeiculo excluir={this.excluir} veiculo={this.state.veiculoSelecionado} />
          <ModalLocalizacaoVeiculo />
        </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    veiculos: state.veiculos.veiculos,
    resumoVeiculo: state.veiculos.resumoVeiculo,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualVeiculo,
    registrosPorPagina: state.registrosPorPaginaVeiculo,
    changeFieldValue,
  }
);

export default connect(mapStateToProps, {
  buscarVeiculos,
  excluirVeiculo,
  filtrarResumoVeiculo,
  selecionarVeiculo,
  alterarMapaSelecionadoVeiculo
})(reduxForm({
  form: 'formularioPainelCadastroVeiculo'
})(PainelGerenciarVeiculos))
